import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { SdRecipeSliderComponent } from '@seb/web-design-system/recipe-slider';
import { BrandsEnum, IRichParagraph, SdRichParagraphComponent, SizesEnum } from '@seb/web-design-system/core';
import { IRecipeCard, IRecipeCardWithLayout } from '@seb/web-design-system/recipe-card';
import { TrackingService } from '@seb/web-common/core/services';

@Component({
  selector: 'wc-recipe-slider',
  templateUrl: './recipe-slider.component.html',
  standalone: true,
  imports: [SdRichParagraphComponent, SdRecipeSliderComponent]
})
export class RecipeSliderComponent {
  @Input()
  recipeCards: IRecipeCardWithLayout[];

  @Input()
  brand: BrandsEnum;

  contentData: IRichParagraph;
  SizeEnum = SizesEnum;

  constructor(
    private trackingService: TrackingService,
    translateService: TranslateService
  ) {
    this.contentData = {
      heading: {
        data: {
          title: translateService.instant('recipes.similarRecipes')
        }
      }
    };
  }

  onClickCard(recipe: IRecipeCard) {
    this.trackingService.sendEvent('clickSimilarRecipe', { recipeName: recipe?.title });
  }
}
